import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {
    amountWithNegativesDataTableTemplate,
    percentageDataTableTemplate,
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
} from "../../utils/formatters/Numbers";
import HeaderPage from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const BilateralGuaranteeData = (props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <HeaderPage header="Garantías Asignadas" isBold={true}/>
            </Grid>
            <Grid item xs={12}>
                <DataTable
                    value={props.collateralAssignedList}
                    footerColumnGroup={props.footerColumnGroup}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="composeName" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="valueType" header="Tipo Valor" style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="title" header="Títulos" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="price" header="Precio" style={{textAlign: 'right'}}
                            body={priceDataTableTemplate} sortable={true}/>
                    <Column field="amount" header="Importe" style={{textAlign: 'right'}}
                            body={amountWithNegativesDataTableTemplate} sortable={true}/>
                    <Column field="haircut" header="% Aforo" style={{textAlign: 'right'}}
                            body={percentageDataTableTemplate} sortable={true}/>
                    <Column field="coveragePercent" header="% Garantía" style={{textAlign: 'right'}}
                            body={percentageDataTableTemplate} sortable={true}/>
                    <Column field="operation" header="Operación" style={{textAlign: 'left'}} sortable={true}/>
                </DataTable>
            </Grid>
        </Grid>
    )
};

export default BilateralGuaranteeData;

BilateralGuaranteeData.propTypes = {
    collateralAssignedList: PropTypes.array.isRequired,
    footerColumnGroup: PropTypes.object.isRequired
};